export default __webpack_public_path__ + "fb50655fd9d6bf425fd0d207801a14a7.png";